import { useState, useEffect } from 'react'
import * as _ from 'lodash'
import useTranslate from '../../../i18n/useTranslate'

import { VictoryBar, VictoryChart, VictoryAxis, VictoryTooltip, VictoryLabel } from 'victory'
import { makeStyles, Typography } from '@material-ui/core'
import EmptyData from '../officer/EmptyData'

type AverageProjectType = {
    label: {
        th: string
        en: string
    }
    id: number
    value: number
    color: string[]
}

type AverageProjectTimeComponentProps = {
    data: AverageProjectType[]
}

const AverageProjectTime = ({ data }: AverageProjectTimeComponentProps) => {
    const translate = useTranslate()
    const classes = useStyles()
    const lang = translate.languageStore.currentLanguage as 'th' | 'en'

    const [projectList, setProjectList] = useState<AverageProjectType[]>([])

    useEffect(() => {
        const sortData = _.orderBy(data, ['id'], ['desc'])
        setProjectList(sortData)
    }, [data])

    const TootipChartComponent = ({ ...props }) => {
        const { x, y, datum, dx, dy } = props
        return (
            <g>
                <foreignObject
                    x={x - 30}
                    y={y - 20}
                    width={120}
                    height={30}
                    dx={dx}
                    dy={dy}
                    fill="white"
                    stroke="#868C97"
                    stroke-width="0.5"
                >
                    <div
                        style={{
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            fontFamily: 'Prompt',
                            fontSize: '8px',
                        }}
                    >
                        {`${datum.x} : ${datum.y} ${translate.get('UM.DASHBOARD.UNIT_DAY')}`}
                    </div>
                </foreignObject>
            </g>
        )
    }

    return (
        <>
            <Typography className={classes.header}>{translate.get('UM.DASHBOARD.AVERAGE_PROJECT')}</Typography>
            <div className={classes.chart}>
                {projectList &&
                    projectList.length > 0 &&
                    projectList.map((item: AverageProjectType, index: number) => {
                        return (
                            <svg viewBox="0 0 0  0" height={0} width={0}>
                                <defs>
                                    <linearGradient id={`myGradient${index}`} x1="0%" y1="0%" x2="100%" y2="0%">
                                        <stop offset="0%" stopColor={`${item.color[0]}`} />
                                        <stop offset="100%" stopColor={`${item.color[0]}`} />
                                    </linearGradient>
                                </defs>
                            </svg>
                        )
                    })}

                <EmptyData isEmpty={_.isEmpty(data)}>
                    <VictoryChart
                        horizontal
                        domainPadding={20}
                        padding={{ bottom: 48, left: 48, right: 32, top: 16 }}
                        height={200}
                        width={300}
                    >
                        <VictoryAxis
                            label={() => ''}
                            standalone={false}
                            axisLabelComponent={
                                <VictoryLabel angle={0} dx={25} dy={-75} text={translate.get('UM.DASHBOARD.TYPE')} />
                            }
                            tickValues={projectList.map((item: AverageProjectType, index: number) => index + 1)}
                            tickFormat={projectList.map((item: AverageProjectType) => item.label[lang])}
                            style={{
                                axisLabel: {
                                    fontSize: '8px',
                                    fill: '#B9B9B9',
                                    fontFamily: 'Prompt',
                                },
                                axis: { stroke: '#BDBDBD' },
                                tickLabels: { fontSize: '8px', padding: 5, fill: '#3B4859', fontFamily: 'Prompt' },
                            }}
                        />
                        <VictoryAxis
                            dependentAxis
                            standalone={false}
                            label={() => ''}
                            axisLabelComponent={
                                <VictoryLabel dx={120} dy={-30} text={translate.get('UM.DASHBOARD.UNIT_DAY')} />
                            }
                            tickLabelComponent={<VictoryLabel style={{ fontSize: '8px' }} />}
                            style={{
                                axisLabel: {
                                    fontSize: '8px',
                                    fill: '#B9B9B9',
                                    fontFamily: 'Prompt',
                                },
                                grid: { stroke: '#BDBDBD', strokeWidth: '0.5' },
                                axis: { stroke: '#BDBDBD' },
                                tickLabels: { fontSize: '8px', padding: 5, fill: '#3B4859', fontFamily: 'Prompt' },
                            }}
                        />

                        <VictoryBar
                            labelComponent={
                                <VictoryTooltip
                                    cornerRadius={0}
                                    pointerLength={0}
                                    flyoutComponent={<TootipChartComponent />}
                                />
                            }
                            style={{
                                data: {
                                    fill: (datum) => {
                                        return `url(#myGradient${datum.index})`
                                    },
                                    width: 15,
                                },
                            }}
                            data={projectList.map((item: AverageProjectType) => {
                                return { x: item.label[lang], y: item.value }
                            })}
                            labels={() => ''}
                        />
                    </VictoryChart>
                </EmptyData>
            </div>
        </>
    )
}

const useStyles = makeStyles(() => ({
    header: {
        margin: '0px 8px',
        fontWeight: 'bold',
    },
    chart: {
        display: 'block',
        padding: 0,
        margin: 0,
        height: '340px',
    },
}))

export default AverageProjectTime
